import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { Route } from '@/routes';

export const UserManagementWrapper: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Breadcrumb label={t('user-management.title')} to={`/${Route.USER_MANAGEMENT}`} />
      <Outlet />
    </>
  );
};
